import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { CSSTransitionGroup } from '@/ui/ReactTransitionGroup'
import classNames from 'classnames'
import compose from 'recompose/compose'

import translate from '@/i18n/translate'

import cloneReactChildren from '@/helpers/cloneReactChildren'
import Tooltip from '@/ui/Tooltip'
import { Button } from '@/ui/Button'

import CloseIcon from '@/icons/Remove'
import ClickAwayListener from '@/ui/ClickAwayListener'

import { /* showModal, */ hideModal } from '@/state/actions/modal'

function FirstChild(props) {
  const childrenArray = React.Children.toArray(props.children)
  return childrenArray[0] || null
}

export class Modal extends Component {
  static propTypes = {
    theme: PropTypes.object.isRequired,
  }

  static defaultProps = {
    transition: {
      leave: false,
      enter: true,
      component: FirstChild,
      transitionEnterTimeout: 300,
      transitionLeaveTimeout: 300,
    },
  }

  handleOnOutsideClick = e => {
    if (!this.props.params.sticky) {
      this.props.dispatch(hideModal())
    }
  }

  removeModal = e => {
    this.props.dispatch(hideModal())
  }

  mapParts = (parts, record) => {
    return parts.map(part => (
      <Choose>
        <When condition={part.startsWith('$')}>
          <With property={part.substring(1)}>
            <span className={property} key={property}>
              {record[property]}
            </span>
          </With>
        </When>
        <Otherwise>{part}</Otherwise>
      </Choose>
    ))
  }

  render() {
    const { theme, transition, /* showModal, hideModal, */ params } = this.props // eslint-disable-line no-unused-vars
    const { type, record, size, hideClose, sticky, buttons, buttonActions, ...rest } = params
    let { title, content } = rest

    const visible = Object.keys(this.props.params).length !== 0
    const transitionName = {
      enter: theme['modal-enter'],
      enterActive: theme['modal-enter-active'],
      leave: theme['modal-leave'],
      leaveActive: theme['modal-leave-active'],
    }

    if (record) {
      // Evaluates $variables in title to record[$variables] and wraps them in span tag
      // this is done so we can accent some parts in the title / content by styling the span tag
      let $parts = title.split(/(\$[A-z]+)/)
      if ($parts.length > 1) {
        title = this.mapParts($parts, record)
      }

      // Do the same for content text
      $parts = content.split(/(\$[A-z]+)/)
      if ($parts.length > 1) {
        content = this.mapParts($parts, record)
      }
    }

    return (
      <CSSTransitionGroup {...transition} transitionName={transitionName}>
        <If condition={visible}>
          <div className={theme['modal']}>
            <div className={theme['modal-scroll']}>
              <ClickAwayListener onClickAway={this.handleOnOutsideClick}>
                <div
                  className={classNames(theme['modal-content'], theme[`modal-${size || 'medium'}`])}
                >
                  <If condition={title}>
                    <div className={theme['modal-header']}>
                      <h2>{title}</h2>
                    </div>
                  </If>
                  <If condition={!hideClose}>
                    <button
                      type="button"
                      className={classNames(theme['modal-close'], theme['modal-icon-cancel'])}
                      onClick={this.removeModal}
                    >
                      <Tooltip content="Close modal" theme={theme}>
                        <CloseIcon size="40" />
                      </Tooltip>
                    </button>
                  </If>
                  <div className={theme['modal-body']}>{content || ''}</div>
                  <div className={theme['modal-footer']}>
                    <If condition={buttons}>{cloneReactChildren(buttons, { theme })}</If>
                    <If condition={buttonActions}>
                      <For each="buttonAction" index="idx" of={buttonActions}>
                        <Button
                          key={idx}
                          onClick={() => {
                            this.props.dispatch(buttonAction.action())
                            this.props.dispatch(hideModal())
                          }}
                        >
                          {buttonAction.label}
                        </Button>
                      </For>
                    </If>
                  </div>
                </div>
              </ClickAwayListener>
            </div>
            <div className={theme['modal-shadow']} />
          </div>
        </If>
      </CSSTransitionGroup>
    )
  }
}

export function mapStateToProps(state, ...ownProps) {
  const { ui: { modal: { params = {}, visible } } } = state
  return {
    visible,
    params,
    ...ownProps,
  }
}

// export function mapDispatchToProps(dispatch) {
//   return bindActionCreators({ showModal, hideModal }, dispatch)
// }

// const connector = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(connect(mapStateToProps), translate)

// export default connector(Modal)
export default enhance(Modal)



// WEBPACK FOOTER //
// ./ui/Modal/Modal.js